import SignInController from './controller/SignInController.js'
const template = require('./signIn.component.tpl.pug')

const signIn = {
  template: template(),
  controller: SignInController,
}

export default signIn
